import { AuthUser } from 'components/Session/withAuthentication'
import { IReduxAction } from '../IReduxAction'
import { AUTH_USER_ACTION_TYPES } from './types'

export interface IPlusUserState {
  authUser: AuthUser
}

export const initState: IPlusUserState = {
  authUser: undefined
}

export default (state = initState, action: IReduxAction): IPlusUserState => {
  switch (action.type) {
    case AUTH_USER_ACTION_TYPES.set_auth_user:
      const { authUser } = action.payload.data

      return {
        authUser
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/authUser/index.ts